import { z } from 'zod';

export const CoreNotifyAnonymousContactScalarFieldEnumSchema = z.enum(['id','cityId','createdAt','updatedAt','phoneNumber','phoneNumberOptedInAt','phoneNumberOptedOutAt','phoneNumberInvitedAt','phoneNumberInvitationMethod','phoneNumberVerificationMethod','phoneNumberSource','phoneNumberSMSCapable']);

export default CoreNotifyAnonymousContactScalarFieldEnumSchema;
